import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const UserType = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(UserTypeStyled, { ...props }, props.children || lang.roles[props.role]));
};
export default UserType;
export const UserTypeStyled = styled.div `
  background-color: ${(props) => THEME.USER_TYPE_COLORS[props.role]};
  color: ${THEME.COLOR_SECONDARY};
  padding: 0.2em 1.1em;
  border-radius: 0.8em;
  font-size: 0.8em;
  font-weight: bold;
  display: inline-block;
  margin-right: 20px;
`;
//# sourceMappingURL=UserType.js.map